import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ThrottleClickDirective } from '../../../directives/throttle-click.directive';

@Component({
  selector: 'app-black-back-button',
  standalone: true,
  templateUrl: './black-back-button.component.html',
  styleUrls: ['./black-back-button.component.scss'],
  imports: [ThrottleClickDirective],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlackBackButtonComponent {
  @Input() paddingBottomRem = 0;
  @Input() label = $localize`Back`;
  @Output() backClicked = new EventEmitter(true);
}
